import * as React from "react"
import { useParams, useOutletContext } from "react-router-dom"

// components
import ActionItemsGridWrapper from "components/ActionItemsGrid/ActionItemsGridWrapper/ActionItemsGridWrapper"
import WorkflowTracker from "components/WorkflowTracker/WorkflowTracker"
import Team from "components/MyTeamPanel/MyTeamPanel"
import TimelineFeed from "components/TimelineFeed/TimelineFeed"
import ApprovalRecords from "../../ApprovalRecords/ApprovalRecords"
import TrackerHeader from "components/WorkflowTracker/TrackerHeader/TrackerHeader"
import WorkflowModalForm from "components/WorkflowModalForm/WorkflowModalForm"
import RequestFaveButton from "containers/requests/Request/RequestFaveButton/RequestFaveButton"

// styles
import "./RequestWorkflow.scss"

// apis
import { useGetRequest } from "api/hooks/requests/useRequestsApi"
import { useGetRequestRoles } from "api/hooks/users/userRolesApi"
import { useGetRequestTeam, usePostRequestTeam } from "api/hooks/requests/useRequestTeam"
import { useGetRequestActionItems } from "api/hooks/requests/useRequestActionItemsApi"
import { useGetRequestFeed } from "api/hooks/requests/useRequestTimelineApi"

const RequestWorkflow = () => {
  const { requestId } = useParams()

  // local state
  const { onOpenPanel, onClosePanel, breadcrumbsData, setSelectedActionItem, parentQueries } = useOutletContext()
  const [workflowModalOpen, setWorkflowModalOpen] = React.useState(false)
  const [workflowStepId, setWorkflowStepId] = React.useState()
  const [isWorkflowStepResend, setIsWorkflowStepResend] = React.useState()

  // server state
  const { data: request } = useGetRequest(requestId)
  const { data: requestTeam = [] } = useGetRequestTeam(requestId)
  const { data: requestRoles = [] } = useGetRequestRoles(requestId)
  const { data: actionItems = [], refetch: refetchActionItems } = useGetRequestActionItems(requestId)
  const { data: requestFeed = [], refetch: refetchFeed } = useGetRequestFeed(requestId)
  const postRequestTeam = usePostRequestTeam(requestId)

  React.useEffect(() => {
    return () => {
      onClosePanel()
    }
  }, [])

  const onOpenWorkflowModal = ({ stepId, isResend = false }) => {
    setWorkflowStepId(stepId)
    setIsWorkflowStepResend(isResend)
    setWorkflowModalOpen(true)
  }

  return (
    <>
      <TrackerHeader
        model="request"
        title={request?.request_id}
        status={request?.status}
        breadcrumbs={breadcrumbsData}
        workflowId={request?.workflow_id}
        workflowObj={request}
        onOpenPanel={onOpenPanel}
        showWorkFlowActions={true}
        actions={[<RequestFaveButton request={request} />]}
        onOpenWorkflowModal={onOpenWorkflowModal}
      />
      <div className="request-workflow">
        <WorkflowTracker
          model={"request"}
          workflowId={request?.workflow_id}
        />
        <ActionItemsGridWrapper
          type={"request"}
          onOpenPanel={() => onOpenPanel("action-items")}
          actionItems={actionItems}
          setSelectedActionItem={setSelectedActionItem}
          refetchActionItems={refetchActionItems}
        />
        <div className="panel-cols">
          <TimelineFeed
            type="request"
            timeline={requestFeed?.timeline}
            modalMsg={`${request?.request_id} - ${request?.request_type_name}`}
            refetchTimeline={refetchFeed}
            panelClassName="request-feed-panel"
          />
          <Team
            type={"request"}
            team={requestTeam}
            roles={requestRoles}
            postTeam={postRequestTeam}
            panelClassName="request-team-panel"
          />
          <ApprovalRecords panelClassName="panel-col request-approval-panel" />
        </div>
      </div>
      <WorkflowModalForm
        open={workflowModalOpen}
        setOpen={setWorkflowModalOpen}
        stepId={workflowStepId}
        isResend={isWorkflowStepResend}
        parentQueries={parentQueries}
      />
    </>
  )
}

export default RequestWorkflow
